import type { TimelineProposal } from "@/compiler/Timeline/timeline.proposals";
import { useOmniCine } from "@/state/useOmniCine";
import type { NarrativeGroup } from "@/components/OmniCine/DirectorPanel/ProposalGroup";

type DirectorCompilerProposal = TimelineProposal & {
  narrative?: {
    summary?: string;
    groups?: NarrativeGroup[];
  };
};

type DirectorCompilerState = {
  ui?: {
    directorProposals?: DirectorCompilerProposal[];
  };
};

export function useDirectorCompilerReadOnly() {
  const { state } = useOmniCine();
  const compilerState = state as unknown as DirectorCompilerState;

  const proposals = compilerState.ui?.directorProposals ?? [];

  const narrativeSummary =
    proposals[0]?.narrative?.summary ??
    "No narrative assessment for this scene.";

  const groups =
    proposals[0]?.narrative?.groups ?? [];

  return {
    narrativeSummary,
    groups,
    proposals,
  };
}
